// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
// (拡散ページではフォローボタンがページトップにあるためスクロールリスナーは必要なく、パフォーマンス観点で改善余地あり)

function initializeTwitterFollowButton(twitterHandle) {
  if (!twitterHandle) return; // NOTE: undefinedになる際に必要なくスクロールにリスナーが付くことを避けるために追加

  const twBtnHtml = `<a href="https://twitter.com/${twitterHandle}" class="twitter-follow-button" data-show-count="false" data-show-screen-name="false"> @${twitterHandle}をフォローする</a>${TW_JS}`;
  let buttonAppended = false;

  $(window).on("scroll", () => {
    const snsZone = $("#jsSnsFollow");
    if (!snsZone.length) return;

    const snsAreaTopPos = snsZone.offset().top;
    const scrollPos = $(window).scrollTop();
    const wh = $(window).height();

    if (scrollPos > snsAreaTopPos - wh && !buttonAppended) {
      snsZone.append(twBtnHtml);
      buttonAppended = true;
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeTwitterFollowButton;